import { call, put, takeLatest } from 'redux-saga/effects'
import { USER_RESET_PASSWORD_REQUEST, USER_CHECK_TOKEN_REQUEST} from './constants';
import { resetPassSuccess, resetPassFailure, checkTokenSuccess, checkTokenFailure } from "./actions";
import remote from '../../../../services/remote'
import SentryManager from "../../../../monitoring/Sentry";

function* resetPassword (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/update-password-and-login',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(resetPassSuccess(response.data));
        } else {
            yield put(resetPassFailure(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

function* checkToken (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/check-token',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(checkTokenSuccess(response.data));
        } else {
            yield put(checkTokenFailure(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

export default function* watchResetPasswordSaga() {
    yield takeLatest(USER_RESET_PASSWORD_REQUEST , resetPassword);
    yield takeLatest(USER_CHECK_TOKEN_REQUEST , checkToken);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ResetPassword/saga.js